import styled from 'styled-components';
import { Col } from 'reactstrap';
import colors from '../../../../../../includes/colors';

export const Title = styled.h4`
  color: ${colors.darkBlue};
  font-weight: 400;
  font-size: 0.875rem;
  strong {
    font-weight: 700;
  }
`;

export const Text = styled.div`
  color: ${colors.black};
  font-weight: 400;
  font-size: 0.875rem;
  strong {
    font-weight: 700;
  }
`;

export const ShowMore = styled.a`
  color: ${colors.darkBlue} !important;
  font-weight: 400;
  font-size: 0.875rem;
  cursor: pointer;
`;

export const Block = styled(Col)``;
